import * as yup from 'yup';
import { stringReqSchema } from '../../../utils';

const rules = yup.object({
  name: stringReqSchema('Name'),
  email: stringReqSchema('Email'),
  country: stringReqSchema('Country'),
  city: stringReqSchema('City'),
  message: stringReqSchema('Message'),
});

export default rules;
